<template>
    <div>
        <oc-plugin-slot name="before-content" v-bind="col" ref="beforeContent" />

        <div v-if="actions.length" class="oc-table-actions">
            <template v-if="$source.actionsType === 'inline'">
                <oc-action
                    v-for="(action, index) in getVisibleActions()"
                    v-class="getActionClass(index)"
                    :row="row"
                    :key="index"
                    v-bind="action"
                />
            </template>
            <oc-dropdown
                v-else
                :actions="actions"
                align="right"
                :row="row"
                v-bind="$source.actionsDropdownAttrs"
            >
                <oc-button-input class="oc-dropdown-link btn btn-outline-secondary" slot="button" slot-scope="{toggle}" @click="toggle">
                    <oc-icon type="caret-down" />
                </oc-button-input>
            </oc-dropdown>
        </div>

        <oc-plugin-slot name="after-content" v-bind="col" ref="afterContent" />
    </div>
</template>

<script>
export default {
    name: 'oc-action-row-cell',
    inject: ['$source'],
    props: ['row', 'col', 'index', 'options'],
    computed: {
        actions() {
            return typeOf( this.$source.actions ) === 'function'
                ? this.$source.actions(this.row, this.col, this.index, this.options)
                : this.$source.actions
        }
    },
    methods: {
        getActionClass(index) {
            let length = this.getVisibleActions().length

            return {
                action: true,
                first: index == 0 && length > 1,
                last: index == length - 1
            }
        },
        getVisibleActions() {
            let visible = []
            for( let action of this.actions ) {
                if( this.isActionVisible(action) ) {
                    visible.push(action)
                }
            }
            return visible
        },
        isActionVisible(action) {
            let visible = action.visible === undefined
                                ? true
                                : action.visible

            visible = typeOf(visible) === 'function'
                            ? visible(this.row)
                            : Boolean(visible)

            return visible && (action.title || action.icon)
        }
    }
}
</script>

<style scoped>
    a.action {margin-right: 6px; padding-right: 4px; border-right: solid 1px #ccc;}
    a.action.last {margin-right: 0; padding-right: 0; border-right: none;}

    .oc-dropdown-link {
        width: 20px;
        height: 20px;
        line-height: 20px;
        padding: 0;
        border-radius: 35px !important;
        text-align: center;
        font-size: 12px;
    }
</style>
